// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".WinBackPing-cls1__a6a147cad5dd9ca02627{/*!*/}.WinBackPing-cls2___0cb65ed46221bfeef58{width:120px;max-width:100%}@media screen and (min-width: 950px){.WinBackPing-cls2___0cb65ed46221bfeef58{width:218px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "WinBackPing-cls1__a6a147cad5dd9ca02627",
	"cls2": "WinBackPing-cls2___0cb65ed46221bfeef58 WinBackPing-cls1__a6a147cad5dd9ca02627"
};
export default ___CSS_LOADER_EXPORT___;
